import React, { useEffect, useState } from 'react';
import {
    Slider,
    Input,
    TextArea,
    Button
} from '@kaleyra/kds';
import Styles from "../../Notifications.module.scss";
import { useTranslation } from 'react-i18next';
import infoIcon from '../../../../../assets/infoIconBlack.svg';
import { Spinner } from '@kaleyra/emmy';
import { maxEmailLimit } from '../../../../../constants';
import { validateEmail } from '../../../../../utils';
import { useSelector } from 'react-redux';
import { IStateType } from '../../../../../store/models/root.interface';
import KDSToast from '../../../../../components/KDSToast';

export type MapStatePropsType = {
    sidebarVisibility: boolean;
    params: any;
};

export type DispatchPropsType = {
    onClose: () => void;
    onSave: (data: any, callBack: any) => void;
    onLoad: () => void;
};

const AlertConfig: React.FC<MapStatePropsType & DispatchPropsType> = ({
    onClose,
    onLoad,
    onSave,
    params,
    sidebarVisibility
}) => {

    const { t } = useTranslation();
    const [creditLimit, setCreditLimit] = useState('');
    const [creditLimitErr, setCreditLimitErr] = useState('');
    const [emailIdsStr, setemailIdsStr] = useState('');
    const [emailIdsStrErr, setemailIdsStrErr] = useState('');
    const [saving, setSaving] = useState(false);
    const symbol = useSelector((state: IStateType) => state.balance?.fullBalanceObject?.base_currency_symbol);
    const { balance_alert, balance_alert_emails_prefill, balance_alert_limit, is_prepaid } = params;

    useEffect(() => {
        if (balance_alert || balance_alert_limit) {
            setemailIdsStr(balance_alert_emails_prefill);
            setCreditLimit(balance_alert_limit);
        }
    }, []);

    const handleOnSave = () => {
        setSaving(true);
        onSave(({ limit: creditLimit, emails: emailIdsStr, checked: 1 }), (resp: any, success: boolean) => {
            if (success) {
                KDSToast(resp?.message, "success");
                onLoad();
                onClose();
            } else {
                KDSToast(resp?.message, "error");
                setSaving(false);
            }
        });
    };

    const validateCheck = (field: string) => {

        if (field === 'creditLimit') {
            if (creditLimit?.trim() === '') {
                return t('titleReq');
            } else if (isNaN(Number(creditLimit))) {
                return t('KLR02858');
            }
            if (creditLimit?.length > 5) {
                return t('KLR02857');
            }
            if (Number(creditLimit) <= 0) {
                return t('KLR02857a');
            }
            else {
                return;
            }
        }
        if (field === 'emailIdsStr') {
            if (emailIdsStr.trim() === '') {
                return t('titleReq');
            }

            let emails = emailIdsStr.split(",");
            const duplicateAddresess = emails.filter((item: any, index: number) => emails.indexOf(item) !== index);

            if (emails.length > maxEmailLimit) {
                return t("KLR02734", { limit: maxEmailLimit });
            }
            if (duplicateAddresess.length > 0) {
                return t("KLR02735");
            }
            for (let i = 0; i < emails.length; i++) {
                if (!validateEmail(emails[i])) {
                    return t('verifyValidEmail');
                }
            }
            return;
        }
        return ''
    };

    const validateFields = (field: string): 'error' | undefined => {
        if (validateCheck(field)) {
            return "error";
        };
        return undefined;
    };

    const setErrors = (field: string) => {
        let errMsg = validateCheck(field);
        if (errMsg) {
            return (
                <div className={Styles.errorClass}>
                    {errMsg}
                </div>
            );
        };
    };

    const handleCreditLimitOnBlur = () => {
        let errMsg = validateCheck('creditLimit');
        if (errMsg) {
            setCreditLimitErr(errMsg);
            return;
        } else {
            setCreditLimitErr('');
            return;
        }
    };

    const handleEmailsOnBlur = () => {
        let errMsg = validateCheck('emailIdsStr');
        if (errMsg) {
            setemailIdsStrErr(errMsg);
            return;
        } else {
            setemailIdsStrErr('');
            return;
        }
    };

    const checkSaveButtonEnabled = () => {
        if (saving || validateFields("creditLimit") || validateFields("emailIdsStr")) return true;

    };

    const getFooter = () => {

        return (
            <div className={Styles.actionItems}>
                <div className={Styles.cancelBtnWrapper}>
                    <Button type="default" className={Styles.cancelBtn} onClick={onClose}>
                        {t('mainCancel')}
                    </Button>
                </div>
                <div className={Styles.saveBtnWrapper}>
                    <Button
                        className={Styles.saveBtn}
                        type="primary"
                        onClick={handleOnSave}
                        disabled={checkSaveButtonEnabled()}
                    >
                        {saving ? <Spinner margin={"0.5rem"} color='#636C75' /> : t('mainSave')}
                    </Button>
                </div>
            </div>
        )
    };

    const getContent = () => {

        return (
            <div>
               {is_prepaid && (
                <Input
                    placeholder={t('KLR02843', { symbol: symbol })}
                    style={{ marginBottom: 24 }}
                    label={t('KLR02842')}
                    maxLength={5}
                    value={creditLimit}
                    statusType={creditLimitErr ? validateFields('creditLimit') : undefined}
                    statusContent={creditLimitErr ? setErrors('creditLimit') : null}
                    onChange={(e: any) => {
                        setCreditLimitErr('');
                        setCreditLimit(e.target.value);
                    }}
                    onBlur={() => {
                        handleCreditLimitOnBlur();
                    }}
                />
            )}

                <TextArea
                    placeholder={t('KLR02844')}
                    statusType={emailIdsStrErr ? validateFields('emailIdsStr') : undefined}
                    statusContent={emailIdsStrErr ? setErrors('emailIdsStr') : null}
                    label={'Send Email To'}
                    onChange={(e: any) => {
                        setemailIdsStrErr('');
                        setemailIdsStr(e.target.value);
                    }}
                    onBlur={() => {
                        handleEmailsOnBlur();
                    }}
                    value={emailIdsStr}
                />
                {
                    !emailIdsStrErr &&
                    <div className={Styles.dF}>
                        <img
                            src={infoIcon}
                            alt="info"
                            className={Styles.infoIcon}
                        />
                        <div className={Styles.emailsTextArea}>{t('BLD00141')}</div>
                    </div>
                }
            </div>
        )
    };

    return (
        <Slider
            containerId="root-modal"
            onClose={() => { onClose() }}
            visibility={sidebarVisibility}
            footer={getFooter()}
            label={is_prepaid ? t('BLD00135') : t('BLD00135a')}
        >
            {getContent()}
        </Slider>
    );
};

export default AlertConfig;
